export default __webpack_public_path__ + "static/media/qr_appstore_ikara.0326aeaf.svg";